import React, { useState } from "react";
import siteConfig from "../config/siteConfig";
import "../css/contactus.scss";

const emptyForm = { firstName: "", lastName: "", email: "", phone: "", subject: "", message: "" };

function Contact() {
  const [form, setForm] = useState(emptyForm);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const update = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    if (errors[name]) setErrors((current) => ({ ...current, [name]: "" }));
  };

  const submit = (event) => {
    event.preventDefault();
    const next = {};
    if (!form.firstName.trim()) next.firstName = "First name is required";
    if (!form.lastName.trim()) next.lastName = "Last name is required";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) next.email = "Enter a valid email";
    if (!form.subject) next.subject = "Choose a subject";
    if (form.message.trim().length < 10) next.message = "Tell us a little more";
    if (Object.keys(next).length) {
      setErrors(next);
      return;
    }
    setSubmitting(true);
    window.setTimeout(() => {
      setSubmitting(false);
      setSent(true);
      setForm(emptyForm);
    }, 650);
  };

  return (
    <main className="contact-page">
      <header className="contact-hero">
        <p className="eyebrow">WE ARE HERE</p>
        <h1>How can we help?</h1>
        <p>Our team reads every note and usually replies within one business day.</p>
      </header>

      <div className="contact-layout">
        <aside className="contact-details">
          <div><h2>Write to us</h2><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a><p>{siteConfig.contact.hours}</p></div>
          <div><h2>Company</h2><p>{siteConfig.contact.company}</p></div>
          <div><h2>Registered address</h2><address>{siteConfig.contact.address}</address></div>
          <div><h2>Quick answers</h2><p>For delivery timing, returns and exchanges, our dedicated guides may have what you need.</p></div>
        </aside>

        <section className="contact-form-wrap">
          {sent ? (
            <div className="contact-success" role="status"><p className="eyebrow">MESSAGE SENT</p><h2>Thank you for writing.</h2><p>We will be in touch shortly.</p><button type="button" className="text-link" onClick={() => setSent(false)}>Send another note</button></div>
          ) : (
            <form className="contact-form" onSubmit={submit} noValidate>
              <div className="contact-form__row">
                {[{ name: "firstName", label: "First name" }, { name: "lastName", label: "Last name" }].map((field) => (
                  <label key={field.name}><span>{field.label}</span><input name={field.name} value={form[field.name]} onChange={update} />{errors[field.name] && <small>{errors[field.name]}</small>}</label>
                ))}
              </div>
              <label><span>Email</span><input type="email" name="email" value={form.email} onChange={update} />{errors.email && <small>{errors.email}</small>}</label>
              <label><span>Phone (optional)</span><input name="phone" value={form.phone} onChange={update} /></label>
              <label><span>How can we help?</span><select name="subject" value={form.subject} onChange={update}><option value="">Select a subject</option><option>Order & delivery</option><option>Return or exchange</option><option>Product & sizing</option><option>Store information</option><option>Something else</option></select>{errors.subject && <small>{errors.subject}</small>}</label>
              <label><span>Message</span><textarea name="message" rows="7" value={form.message} onChange={update} />{errors.message && <small>{errors.message}</small>}</label>
              <button className="button button--dark" type="submit" disabled={submitting}>{submitting ? "Sending…" : "Send message"}</button>
            </form>
          )}
        </section>
      </div>
    </main>
  );
}

export default Contact;
